const getCallBacks = (editor) => {
  const handleSetLink = () => {
    const previousUrl = editor.getAttributes('link').href;
    const url = window.prompt('URL', previousUrl);

    // cancelled
    if (url === null) {
      return;
    }

    // empty
    if (url === '') {
      editor.chain().focus().extendMarkRange('link').unsetLink().run();

      return;
    }

    // update link
    editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
  };

  const handleToggleBold = () => {
    editor.chain().focus().toggleBold().run();
  };

  const handleToggleItalic = () => {
    editor.chain().focus().toggleItalic().run();
  };

  const handleToggleParagraph = () => {
    editor.chain().focus().setParagraph().run();
  };

  const handleToggleBulletList = () => {
    editor.chain().focus().toggleBulletList().run();
  };

  const handleToggleOrderedList = () => {
    editor.chain().focus().toggleOrderedList().run();
  };

  const handleToggleBlockquote = () => {
    editor.chain().focus().toggleBlockquote().run();
  };

  const handleToggleHorizontalLine = () => {
    editor.chain().focus().setHorizontalRule().run();
  };

  const handleToggleBreak = () => {
    editor.chain().focus().setHardBreak().run();
  };

  const handleClear = () => {
    editor.chain().focus().unsetAllMarks().clearNodes().run();
  };

  const handleUndo = () => {
    editor.chain().focus().undo().run();
  };

  const handleRedo = () => {
    editor.chain().focus().redo().run();
  };

  //
  const handleChackIsActive = (buttonName) => editor.isActive(buttonName);

  const handleCheckUndo = () => {
    return !editor.can().chain().focus().undo().run();
  };

  const handleCheckRedo = () => {
    return !editor.can().chain().focus().redo().run();
  };

  return {
    onSetLink: handleSetLink,
    onToggleBold: handleToggleBold,
    onToggleItalic: handleToggleItalic,
    onToggleParagraph: handleToggleParagraph,
    onToggleBulletList: handleToggleBulletList,
    onToggleOrderedList: handleToggleOrderedList,
    onToggleQuote: handleToggleBlockquote,
    onToggleLine: handleToggleHorizontalLine,
    onToggleBReak: handleToggleBreak,
    onClear: handleClear,
    onUndo: handleUndo,
    onRedo: handleRedo,
    checkIsActive: handleChackIsActive,
    checkIsUndoDisabled: handleCheckUndo,
    checkIsRedoDisabled: handleCheckRedo,
  };
};

export { getCallBacks };
